import {
  Button,
  Checkbox,
  Col,
  Form,
  Icon,
  Input,
  message,
  Modal,
  Popconfirm,
  Row,
  Tabs,
  Upload,
} from 'antd'
import { TimelineApi } from '../../../../api/Timeline'
import DocLinkTo from '../../../../components/Common/Documents/Modal/DocLinkTo'
import CustomTable from '../../../../elements/Table/CustomTable'
import ViewDownload from '../../../../elements/ViewDownload'
import { get, pick } from 'lodash'
import Auth from '../../../../modules/Authentication'
import moment from 'moment'
import omitEmpty from 'omit-empty'
import propTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import { streamUrl } from '../../../../variables/index'
import Files from '../../../../api/Files'
import InfoText from '../../../../elements/InfoText'
import Authentication from '../../../../modules/Authentication'
import { dateVal, strVal, timeDateFormat } from '../../../../modules/Utils'

const TabPane = Tabs.TabPane

class File extends Component {
  constructor(props) {
    super(props)
    this.auth = new Authentication()
    this.filesApi = new Files()
    // this.key = props.owner._key
    this.owner = props.owner
    this.state = {
      loading: false,
      updating: false,
      removing: false,
      file: props.file,
      fileList: [],
    }
  }

  auth = new Auth()
  columns = [
    { Header: 'Revision', accessor: 'revision', width: 100 },
    { Header: 'Uploader', accessor: 'uploader.fn' },
    { Header: 'FileName', accessor: 'file' },
    {
      Header: 'Time Uploaded',
      accessor: 'timestamp',
      Cell: ({ value }) => timeDateFormat(dateVal({ value }, 'value')),
    },
    {
      Header: 'File',
      accessor: '_key',
      Cell: ({ original, value }) =>
        value && (
          <ViewDownload
            view={`${streamUrl}files/${value}/revision/${
              original._revID
            }?action=view&access_token=${this.auth.getAccessToken()}`}
            download={`${streamUrl}files/${value}/revision/${
              original._revID
            }?action=download&access_token=${this.auth.getAccessToken()}`}
          />
        ),
    },
  ]
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        const { fileList } = this.state
        const formData = new FormData()
        fileList.forEach((file) => {
          formData.append('upload', file)
        })
        const data = {
          meta: JSON.stringify(
            omitEmpty({
              folder: `${this.owner._id}`,
              timestamp: moment().utc().format(),
              name: values.name,
              description: values.description,
              email: values.email,
              category: values.category,
            })
          ),
        }
        for (let name in data) {
          formData.append(name, data[name])
        }
        this.setState({ updating: true })
        try {
          if (this.props.type === 'edit') {
            const fileData = Object.assign(
              {},
              pick(this.state.file, ['_key', '_rev', '_id']),
              values
            )
            let result
            if (fileList.length === 1) {
              result = await this.filesApi.uploadRevision(this.state.file._key, formData)
            } else {
              result = await this.filesApi.update(fileData)
            }
            result && message.success('Updated !')
            this.setState({ updating: false })
            this.props.handleCancel(true)
          } else if (this.props.type === 'new') {
            let results = await this.filesApi.upload(formData)

            let comment = await TimelineApi.create({
              comment: `File Has been uploaded with name "${values.name || 'N/A'}"`,
              owner: { _id: this.owner._id },
              type: 'parent',
              tag: 'Auto Generated Comment',
            })
            console.log(comment)

            results && message.success('Uploaded!')
            this.setState({ updating: false })
            this.props.handleCancel(true)
          }
        } catch (error) {
          this.setState({ updating: false })
          console.error(error)
          message.error(error.errorMessage)
        }
      }
    })
  }
  handleRemove = async () => {
    try {
      const { _key, _rev, _id } = this.props.file
      this.setState({ removing: true })
      await this.filesApi.remove({ _key, _rev, _id })
      message.success('Removed')
      this.props.handleCancel(true)
    } catch (error) {
      this.setState({ removing: false })
      message.error(error.errorMessage)
    }
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
      },
    }
    const uploadProps = {
      onRemove: (file) => {
        this.setState(({ fileList }) => {
          const index = fileList.indexOf(file)
          const newFileList = fileList.slice()
          newFileList.splice(index, 1)
          return {
            fileList: newFileList,
          }
        })
      },
      beforeUpload: (file) => {
        this.setState(({ fileList }) => ({
          fileList: type === 'new' ? [...fileList, file] : [file],
        }))
        return false
      },
      fileList: this.state.fileList,
    }
    const { getFieldDecorator } = this.props.form
    const {
      type,
      visible,
      handleOk,
      handleCancel,
      editable,
      linkTo,
      linkToType,
      category,

      email,
      emailLabel,
    } = this.props

    const { file } = this.state
    return (
      <Modal
        title={type === 'edit' ? 'Update File Details' : 'Add New Files'}
        visible={visible}
        destroyOnClose={true}
        onOk={handleOk}
        onCancel={handleCancel}
        width={'50%'}
        footer={
          editable && (
            <Row>
              <Col span={24} style={{ textAlign: 'right' }}>
                {type === 'edit' && (
                  <Fragment>
                    <Button
                      icon="eye"
                      target={'_blank'}
                      href={`${streamUrl}files/${
                        file._key
                      }?action=view&access_token=${this.auth.getAccessToken()}`}
                      style={{ marginRight: 5 }}>
                      View
                    </Button>
                    <Button
                      icon="download"
                      target={'_blank'}
                      href={`${streamUrl}files/${
                        file._key
                      }?action=download&access_token=${this.auth.getAccessToken()}`}
                      style={{ marginRight: 5 }}>
                      Download
                    </Button>
                  </Fragment>
                )}
                <Button loading={this.state.updating} type="primary" onClick={this.handleSubmit}>
                  {type === 'edit' ? 'Update' : 'Upload'}
                </Button>
                <Popconfirm
                  title="Are you sure Remove this Files Details?"
                  onConfirm={this.handleRemove}
                  okText="Yes"
                  cancelText="No">
                  {type === 'edit' && (
                    <Button loading={this.state.removing} type="danger" style={{ marginLeft: 8 }}>
                      Remove
                    </Button>
                  )}
                </Popconfirm>
              </Col>
            </Row>
          )
        }>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Document" key="1">
            <Form layout="vertical" onSubmit={this.handleSubmit}>
              <Row>
                <Form.Item {...formItemLayout} label="Name">
                  {getFieldDecorator('name', {
                    initialValue: strVal(file, 'name'),
                    rules: [
                      {
                        required: true,
                        message: "Name can't be empty ",
                      },
                    ],
                  })(<Input placeholder="Name" />)}
                </Form.Item>
                {category === true && (
                  <Form.Item {...formItemLayout} label="Category">
                    {getFieldDecorator('category', {
                      initialValue: strVal(file, 'category'),
                      rules: [
                        {
                          required: true,
                          message: "Category can't be empty ",
                        },
                      ],
                    })(<Input placeholder="Category" />)}
                  </Form.Item>
                )}
                {email === true && (
                  <Form.Item {...formItemLayout} label={emailLabel}>
                    {getFieldDecorator('email', {
                      initialValue: get(file, 'email'),
                      valuePropName: 'checked',
                    })(<Checkbox placeholder="Email" />)}
                  </Form.Item>
                )}
              </Row>

              {linkTo === true && (
                <Row>
                  <DocLinkTo {...this.props} />
                </Row>
              )}

              <Row>
                <Form.Item {...formItemLayout} label="Description">
                  {getFieldDecorator('description', {
                    initialValue: get(file, 'description'),
                  })(<Input placeholder="File Description" />)}
                </Form.Item>
                <Form.Item>
                  {/*{type === 'new' && (*/}
                  <Upload {...uploadProps} multiple={type === 'new'}>
                    <Button>
                      <Icon type="upload" /> {type === 'new' ? 'Select Files' : 'Upload Revision'}
                    </Button>
                  </Upload>
                  {/*)}*/}
                </Form.Item>
              </Row>
            </Form>
            {type === 'new' && <InfoText text={'Tip: you can upload multiple files once'} />}
          </TabPane>
          <TabPane tab="Revision History" key="2" disabled={type === 'new'}>
            <CustomTable
              columns={this.columns}
              data={file.revisions}
              defaultSorted={[
                {
                  id: 'rev',
                  desc: true,
                },
              ]}
            />
          </TabPane>
        </Tabs>
      </Modal>
    )
  }
}

const WrappedFileForm = Form.create()(File)
WrappedFileForm.propTypes = {
  owner: propTypes.object.isRequired,
  category: false,
  email: false,
  linkTo: false,
}
export default WrappedFileForm
